module.exports = __webpack_public_path__ + "media/bootstrap-icons/exclamation-square-fill-5b3c644f.svg";